import React from 'react';
import { Header3Text } from '../../../../ui-toolkit';
import { IStandardDocumentVersionData } from '../../../../types/order/documents/shared/interfaces';
import { GenericEditCreatePolicy } from './GenericEditCreatePolicy';
import { PolicyTypeEnum } from '../../../../policyUI/classes/PolicyTypeEnum';
import { useSelectCurrentOrder } from '../../../../selectors/order/selectCurrentOrder';
import { eTransactionCategory } from '../../../../ui-toolkit/enums/eTransactionType';

export interface IPurchaseTitlePolicyProps {
  isAmericanDigital: boolean;
  ownerPolicy?: IStandardDocumentVersionData;
  label: string;
}

export const PurchaseTitlePolicy: React.FC<IPurchaseTitlePolicyProps> = ({ isAmericanDigital, ownerPolicy, label }) => {
  const { data } = useSelectCurrentOrder();

  const transactionCategory = data.transaction.transaction_category;
  if (transactionCategory !== eTransactionCategory.Purchase) return null;

  return (
    <>
      <Header3Text>Owner's Policy</Header3Text>
      <GenericEditCreatePolicy
        policyType={PolicyTypeEnum.owner}
        isAmericanDigital={isAmericanDigital}
        label={label}
        policy={ownerPolicy}
      />
    </>
  );
};
